import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';

export function provideLottie(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
        provideCacheableAnimationLoader(),
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ]);
}
